export default class DnDGuard {

    constructor() {
        this.sectionsLibraryClass = 'sections-library';
        this.sectionElementPageClass = 'creator-sections-element__section-pageSection';
        this.sectionPageClass = 'creator-workspace__section-pageSection';
        this.typeBagClass = 'creator-workspace__type-bag';
        this.typeWorkSpaceClass = 'creator-workspace__type-workspace';
        this.guTransitClass = 'gu-transit';
        this.creatorSectionElementClass = 'creator-sections-element';
        this.contenteditableSelector = '[contenteditable="true"]';
        this.sectionTypeAttr = 'section-type';
        this.columnResizeHandlerClass = 'column-resizer__handler';
    }

    isColumnResizeHandler(handler) {
        return handler.classList.contains(this.columnResizeHandlerClass);
    }

    isMovable(el, handler) {

        let isContentEditable = this.isContenteditable(el);
        let isColumnResizeHandler = this.isColumnResizeHandler(handler);

        return !isContentEditable && !isColumnResizeHandler;
    }

    isAcceptable(el, target) {
        let toWorkspace = this.isTypeWorkspace(target);
        let toBag = this.isTypeBag(target);
        let isBag = this.isSectionPageInSectionLibrary(el) || // TODO: change type based (page.section) to isBag class
            this.isPageSection(el);

        let isDraggingNow = this.isTransit(target);
        return (toWorkspace || (toBag && !isBag)) && !isDraggingNow;
    }

    getSectionType(el) {
        return $(el).attr(this.sectionTypeAttr);
    }

    isContenteditable(el) {
        return $(el).has(this.contenteditableSelector).length !== 0;
    }

    isTypeBag(el) {
        return el.classList.contains(this.typeBagClass);
    };

    isTypeWorkspace(el) {
        return el.classList.contains(this.typeWorkSpaceClass);
    };

    isSectionPageInSectionLibrary(el) {
        return el.classList.contains(this.sectionElementPageClass)
    };

    isPageSection(el) {
        return el.classList.contains(this.sectionPageClass)
    };

    isTransit(el) {
        return el.classList.contains(this.guTransitClass)
    };

    hasSectionElementClass(el) {
        return $(el).hasClass(this.creatorSectionElementClass)
    };

    isSectionElement(el) {
        return el.classList.contains(this.creatorSectionElementClass)
    }
}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/DnDGuard.js